import "./annualHolidaysPlan.scss";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  DatePickerStyled,
  SnackbarStyled,
} from "../../../helpersComponents/MaterialUi";
import { TopBanner } from "../../../helpersComponents/TopBanner/topBanner";
import AnnualHolidaysPlan from "../../../helpersComponents/AnnualHolidaysPlan/annualHolidaysPlan";

function AnnualHolidaysPlanContent() {
  const { t } = useTranslation();
  const [date, setDate] = useState(new Date());
  const [snackbarState, setSnackbarState] = useState<any>([false, "error", ""]);

  return (
    <>
      <TopBanner pathName={t("annual_holidays_plan")} />

      <div className="flexAndCenter">
        <div className="selectDateDarkGlobal">
          <div className="selectYear dateContainer">
            <div className="inputTitleBonuses">{t("select_date")}</div>
            <div className="selectYearInputBonuses">
              <DatePickerStyled
                view={["year"]}
                format="yyyy"
                date={date}
                setDate={setDate}
                darkTheme={true}
                width={"100%"}
              />
            </div>
          </div>
        </div>
        <div></div>
        <div>
          <AnnualHolidaysPlan
            year={date.getFullYear()}
            setSnackbarState={setSnackbarState}
          />
        </div>
      </div>

      <SnackbarStyled
        setSnackbarState={setSnackbarState}
        snackbarState={snackbarState}
      />
    </>
  );
}

export default AnnualHolidaysPlanContent;
